<template>
  <a
    v-if="href"
    :href="href"
    class="cs-button"
    type="button"
    :class="buttonClasses"
    :style="getStyles()"
    :disabled="disabled || loading"
    @click="$emit('click')"
  >
    <slot />
  </a>

  <button
    v-else
    class="cs-button"
    type="button"
    :class="buttonClasses"
    :style="getStyles()"
    :disabled="disabled || loading"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
import { inArray } from 'lib/component/validators';

/**
* @deprecated Use SimpleButton or LinkButton
* */
export default {
  name: 'Button',
  props: {
    width: {
      type: [String, Number],
      default() {
        return 'auto';
      },
    },
    type: {
      type: String,
      validator: inArray(['primary', 'secondary', 'transparent']),
      default() {
        return 'primary';
      },
    },
    size: {
      type: String,
      validator: inArray(['small', 'medium', 'large']),
      default() {
        return 'medium';
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },

    href: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    buttonClasses() {
      return {
        [this.type]: true,
        [this.size]: true,
        loading: this.loading,
        disabled: this.disabled,
      };
    },
  },
  methods: {
    getStyles() {
      const buttonWidth =
        typeof this.width === 'string' ? this.width : `${this.width}px`;

      return { width: buttonWidth };
    },
  },
};
</script>

<style lang="sass" scoped>
$white: #fff

$primary-base: #7CB342
$primary-active: #5BB100
$primary-disabled: #3A3949

$secondary-base: #27283C

.cs-button
  flex: none
  display: inline-flex
  align-items: center
  justify-content: center
  outline: none
  border: none
  border-radius: 50px
  box-sizing: border-box
  transition: box-shadow 0.16s, background 0.8s
  cursor: pointer

  &.primary
    padding: 16px 50px
    font-weight: 600
    font-size: 18px
    line-height: 18px
    color: $white
    background-color: $primary-base
    box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)

    &:hover
      box-shadow: inset 0px -3px 0px rgba(0, 0, 0, 0.25)

    &:active
      background-color: $primary-active
      box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.25)

    &.disabled,
    &:disabled
      background: $primary-disabled
      box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.25)
      opacity: 0.25
      cursor: default

    &.disabled
      pointer-events: none

  &.secondary
    padding: 10px 35px
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: $white
    background-color: $secondary-base
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15)

    &:hover
      background: linear-gradient(180deg, rgba(50, 53, 81, 0.8) 0%, rgba(39, 40, 60, 0.5) 100%), #27283C
      box-shadow: 0 7px 7px #151928, inset 0px -3px 0px rgba(0, 0, 0, 0.25)

    &:active
      background: linear-gradient(180deg, #27283C 0%, rgba(36, 38, 81, 0) 100%), #2D2D45
      box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.25)

    &.disabled,
    &:disabled
      background: #27283C
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.15)
      cursor: default

    &.disabled
      pointer-events: none

  &.transparent
    padding: 16px 38px
    font-weight: 600
    font-size: 18px
    line-height: 18px
    background-color: transparent

  &.small
    padding: 10px 20px
</style>
